import { Box } from "@mui/material";
import { DotLegalAlert, DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { useSetMonthlySpendingLimitDialogHooks } from "./SetMonthlySpendingLimitDialog.hooks";

export interface ISetMonthlySpendingLimitDialog {
    onDialogClose: () => void;
    onLimitSaved: () => void;
    currentLimit?: number;
    currentMonthlySpendingEur: number;
}

function SetMonthlySpendingLimitDialog(props: ISetMonthlySpendingLimitDialog) {
    const { translateString } = useTranslation();
    const { model, onLimitChange, onSaveClick, inProgress, validation } = useSetMonthlySpendingLimitDialogHooks(props);

    validation.check(model);

    const showBelowCurrentSpendingWarning = model.limit !== "" && Number(model.limit) < props.currentMonthlySpendingEur;

    return (
        <DotLegalDialog
            open
            size="sm"
            header={translateString("setMonthlySpendingLimit")}
            buttonOkText={translateString("save")}
            inProgress={inProgress}
            onDialogClose={props.onDialogClose}
            onOkClick={onSaveClick}
            disableBackdropOnCloseIfValueChange={model}
        >
            <DotLegalTextField
                label={translateString("monthlySpendingLimit")}
                value={model.limit}
                onChange={onLimitChange}
                debounce={false}
                onlyNumber="decimal"
                minNumberValue={0}
                endAdorment={<Box sx={{ color: "text.secondary" }}>EUR</Box>}
                errorText={validation.getErrorsForDisplay("limit")}
            />
            {showBelowCurrentSpendingWarning && (
                <Box mt={2}>
                    <DotLegalAlert warningText={translateString("monthlySpendingLimitBelowCurrentSpendingWarning")} severity="warning" />
                </Box>
            )}
        </DotLegalDialog>
    );
}

export default SetMonthlySpendingLimitDialog;
